import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Typography,
  Box,
  Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './filterPanel.scss';


const FilterPanel = () => {
  const [filters, setFilters] = useState({
    feEfforts: '',
    requirementClarity: '',
    technicalComplexity: '',
    externalIntegration: '',
  });
  const [expandedPanel, setExpandedPanel] = useState(null);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : null);
  };

  const handleCheckboxChange = (category, value) => {
    setFilters((prev) => ({
      ...prev,
      [category]: prev[category] === value ? '' : value,
    }));
  };

  const filterCategories = [
    {
      name: 'FE Efforts',
      options: ['None', 'Very Low', 'Low', 'Medium', 'High', 'Very High'],
      stateKey: 'feEfforts',
    },
    {
      name: 'Requirement Clarity',
      options: ['None', 'Very Low', 'Low', 'Medium', 'High', 'Very High'],
      stateKey: 'requirementClarity',
    },
    {
      name: 'Technical Complexity',
      options: ['None', 'Very Low', 'Low', 'Medium', 'High', 'Very High'],
      stateKey: 'technicalComplexity',
    },
    {
      name: 'External Integration',
      options: ['None', 'Very Low', 'Low', 'Medium', 'High', 'Very High'],
      stateKey: 'externalIntegration',
    },
  ];
  return (
    <Box
      sx={{
        width: '400px',
        backgroundColor: 'white',
        boxShadow: 3,
        borderRadius: 2,
        padding: 2,
        position: 'relative',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between'}}>
        <Typography className="filter-title">
          Filter
        </Typography>
        <Typography variant="subtitle2" color="text.secondary">
          2 Filters Applied
        </Typography>
      </div>

      {filterCategories.map((category) => (
        <Accordion
          key={category.name}
          expanded={expandedPanel === category.stateKey}
          onChange={handleAccordionChange(category.stateKey)}
          disableGutters
          sx={{
            backgroundColor: expandedPanel === category.stateKey ? '#ECEDF4' : 'white',
            border: 'none',
            boxShadow: 'none',
            '&:before': {
              display: 'none',
            },
          }}
        >
          <AccordionSummary
            expandIcon={null}
            sx={{
              fontWeight: 'bold',
              color: expandedPanel === category.stateKey ? '#6B5CE8' : '#000',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Box display="flex" alignItems="center" border="none">
              <ExpandMoreIcon sx={{ mr: 1, color: '#6B5CE8' }} />
              <Typography className="accordion-title">
                {category.name}</Typography>
            </Box>
          </AccordionSummary>
          {category.options && (
            <AccordionDetails>
              {category.options.map((option) => (
                <Box key={option} display="flex" alignItems="center" sx={{ mb: 1 }}>
                  <label style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}>
                    <input
                      type="checkbox"
                      checked={filters[category.stateKey] === option}
                      onChange={() => handleCheckboxChange(category.stateKey, option)}
                      className="custom-checkbox"
                    />
                    <span style={{ marginLeft: '8px'}}>{option}</span>
                  </label>
                </Box>
              ))}
            </AccordionDetails>
          )}
        </Accordion>
      ))}

      <Divider sx={{ my: 2 }} />

      <Box display="flex" justifyContent="flex-end">
        <input
          type="button"
          value="Cancel"
          style={{
            backgroundColor: '#FFFFFF',
            color: '#6B5CE8',
            border: 'none',
            borderRadius: '4px',
            padding: '6px 16px',
            fontFamily: '$muktaMedium',
            fontSize: '$fontMD',
            fontWeight: 550,
            cursor: 'pointer',
          }}
        />

        <Button variant="contained" color="primary">
          Apply
        </Button>
      </Box>
    </Box>
  );
};

export default FilterPanel;
